import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
	{ path: "/", redirect: "/profiles" },
	{
		path: "/profiles",
		name: "profiles",
		component: () => import("@/views/ProfilesPage.vue"),
	},
	{
		path: "/trend-deactivation",
		name: "Trend Deactivation",
		component: () => import("@/views/TrendUnvalidationPage.vue"),
	},
	{
		path: "/posts",
		name: "Posts",
		component: () => import("@/views/PostsPage.vue"),
	},
	{
		path: "/newin",
		name: "Incoming",
		component: () => import("@/views/IncomingPage.vue"),
	},

	{
		path: "/rules",
		name: "Rules",
		component: () => import("@/views/rulesPage.vue"),
	},

	{
		path: "/panels",
		name: "Panels",
		component: () => import("@/views/PanelsMiddlePage.vue"),
	},
	{
		path: "/categories",
		name: "Categories",
		component: () => import("@/views/categoriesPage.vue"),
	},
	{
		path: "/segments",
		name: "Segments",
		component: () => import("@/views/SegmentsPage.vue"),
	},

	{
		path: "/trend-validation",
		name: "trend Validation",
		component: () => import("@/views/TrendValidationPage.vue"),
	},

	{
		path: "/explore",
		name: "Explore",
		component: () => import("@/views/ExplorePage.vue"),
	},

	{
		path: "/animated",
		name: "Animated",
		component: () => import("@/views/AnimatedChartsPage.vue"),
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

export default router;
